const vP18328 = require("./372.js");
const vP183282 = require("./121.js");
function f2187(p18329) {
  this.mode = vP183282.BYTE;
  if (typeof p18329 == "string") {
    p18329 = vP18328(p18329);
  }
  this.data = new Uint8Array(p18329);
}
f2187.getBitsLength = function (p18330) {
  return p18330 * 8;
};
f2187.prototype.getLength = function () {
  return this.data.length;
};
f2187.prototype.getBitsLength = function () {
  return f2187.getBitsLength(this.data.length);
};
f2187.prototype.write = function (p18331) {
  for (let vLN02597 = 0, v14076 = this.data.length; vLN02597 < v14076; vLN02597++) {
    p18331.put(this.data[vLN02597], 8);
  }
};
module.exports = f2187;